/**
 * Created by Angelika on 30.08.2017.
 */
import * as actionTypes from '../constants/actionTypes';
import StalkerApiManager from '../api/StalkerApiLoaderManager';
import {getChannelLink} from '../actions/channelLink';
import {channelCardAdd} from './channelCards';
import {resetVideo} from './video';
import {saveUserConfig} from './userData';
import {onError} from './index';

let api = StalkerApiManager.getInstance();
let loader = api.getLoader();

export function getChannels() {
    return (dispatch, getState) => {
        const {genres} = getState();
        dispatch({type: actionTypes.GET_CHANNELS_REQUEST});
        return loader.getChannels().then(
            data => dispatch({type: actionTypes.GET_CHANNELS_SUCCESS, channels: data, genres: genres.items}),
            error => dispatch(onError(error, actionTypes.GET_CHANNELS_FAILED))
        );
    }
}

export function playChannel(channel, addToCard) {
    return dispatch => {
        dispatch({type: actionTypes.SET_CHANNEL_ACTIVE, channel: channel});
        dispatch(getChannelLink(channel));
        dispatch(resetVideo());
        if (addToCard) {
            dispatch(channelCardAdd(channel));
        }
        dispatch(saveUserConfig());
    }
}

export function playChannelUserConfig() {
    return (dispatch, getState) => {
        const {users: {userData: {config}}} = getState();
        if (config && config.activeChannel) {
            dispatch(playChannel(config.activeChannel, false));
        }
    }
}

export function resetChannelActive() {
    return dispatch => {
        dispatch({type: actionTypes.RESET_CHANNEL_ACTIVE});
        dispatch(saveUserConfig());
    }
}

export function markAsFavorite(channel, isFavorite) {
    return {type: actionTypes.MARK_AS_FAVORITE, channel: channel, isFavorite: isFavorite};
}


// WEBPACK FOOTER //
// ./src/actions/channels.js